import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { ButtonBlockInterface } from '~/types/AppData/PageBuilder/ButtonBlockInterface';
import Button from '~/components/Shared/Buttons/Button';

export default component$<ButtonBlockInterface['props']>(
  ({ variant, text, target, size, url }): JSX.Element => {
    return (
      <Button variant={variant} size={size} target={target} url={url}>
        {text}
      </Button>
    );
  }
);
